import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentProcess from '@/components/PaymentProcess';

interface PaymentData {
  eventId: number;
  mode: 'individual' | 'parejas';
  partner?: any;
  paymentMode: 'my_part' | 'full_amount';
  amount: number;
}

const Payment = () => {
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState<PaymentData | null>(null);
  const [eventTitle, setEventTitle] = useState('');
  const [originalEvent, setOriginalEvent] = useState<any>(null);

  useEffect(() => {
    // Get payment data from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const dataParam = urlParams.get('data');
    const titleParam = urlParams.get('eventTitle');
    const eventParam = urlParams.get('event');

    if (dataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(dataParam));
        setPaymentData(parsedData);
        setEventTitle(titleParam ? decodeURIComponent(titleParam) : 'Evento');
        
        if (eventParam) {
          const parsedEvent = JSON.parse(decodeURIComponent(eventParam));
          setOriginalEvent(parsedEvent);
        }
      } catch (error) {
        console.error('Error parsing payment data:', error);
        navigate('/');
      }
    } else {
      // If no payment data, redirect to home
      navigate('/');
    }
  }, [navigate]);

  const handlePaymentSuccess = () => {
    // Navigate to success page with event and registration data
    const eventData = encodeURIComponent(JSON.stringify(originalEvent || { 
      title: eventTitle,
      id: paymentData?.eventId || Math.random(),
      sport: 'Pádel',
      date: new Date().toISOString().split('T')[0],
      location: 'Club Deportivo'
    }));
    const registrationData = encodeURIComponent(JSON.stringify(paymentData));
    
    navigate(`/payment-success?event=${eventData}&registration=${registrationData}`);
  };

  const handlePaymentError = (error: string) => {
    // Show error message
    alert(`Error en el pago: ${error}`);
  };

  const handleBack = () => {
    // Navigate back to the specific event's registration form using hash fragment
    if (originalEvent) {
      if (originalEvent.isLeague) {
        navigate(`/league/${originalEvent.id}#registration`);
      } else {
        navigate(`/tournament/${originalEvent.id}#registration`);
      }
    } else {
      // Fallback to home if no event data
      navigate('/');
    }
  };

  if (!paymentData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#1b3521] via-[#31633f] to-[#6da079] flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white">Cargando información de pago...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1b3521] via-[#31633f] to-[#6da079] p-4">
      <div className="max-w-2xl mx-auto">
        <PaymentProcess
          paymentData={paymentData}
          eventTitle={eventTitle}
          eventData={originalEvent}
          onPaymentSuccess={handlePaymentSuccess}
          onPaymentError={handlePaymentError}
          onBack={handleBack}
        />
      </div>
    </div>
  );
};

export default Payment;
